{
  "password": {
    "backToLogin": "Back to Login",
    "email": {
      "check": "Check your email",
      "description": "We sent a password reset link",
      "enter": "Enter email",
      "receive": "Didn't receive the email?",
      "resend": "Resend email",
      "title": "Email"
    },
    "forgot": {
      "description": "No worries, we'll send you reset instructions.",
      "title": "Forgot password?"
    },
    "new": "Enter new Password",
    "repeat": "Repeat Password",
    "reset": {
      "setNew": "Create new password",
      "subText": "Your password has been successfully reset",
      "title": "Password reset",
      "invalidLink": {
        "title": "Invalid link",
        "description": "This link is invalid or expired. Please request a new link.",
        "requestNewLink": "Request new link"
      }
    },
    "title": "Password",
    "sso": {
      "linked": {
        "title": "Account linked",
        "description": "Your account has been successfully linked. You can now sign in using your SSO provider."
      },
      "error": {
        "title": "An unexpected error occurred",
        "description": "Please try again. If the problem persists, contact us at support@northhouse.se or +46 (0)8 50 23 52 22"
      },
      "create": {
        "description": "Sign in with your work account to complete the process."
      },
      "conflict": {
        "title": "Linking account failed",
        "description1": "An account with the email address",
        "description2": "already exists. Please contact us at support@northhouse.se if you need support with linking your account."
      }
    },
    "activate": {
      "title": "Password is activated",
      "description": "Your password has been successfully activated",
      "toLogin": "To Login"
    }
  }
}
